import * as types from "./active-question.types.js";
import { getQuestion } from "./questions.resource.js";
import { catchAsyncStacktrace } from "auto-trace";

export function getActiveQuestion(questionName) {
  return (dispatch, getState) => {
    const versionId = getState().smeVersion.version.id;
    const revisionId = getState().smeVersion.revision.id;
    const clientId = getState().client.id;
    const engagementId = getState().engagement.id;

    const activeQuestionSubscription = getQuestion(
      clientId,
      engagementId,
      versionId,
      revisionId,
      questionName
    ).subscribe(question => {
      dispatch({
        type: types.SET_ACTIVE_QUESTION,
        question,
      });
    }, catchAsyncStacktrace());

    dispatch({
      type: types.SET_ACTIVE_QUESTION_SUBSCRIPTION,
      subscription: activeQuestionSubscription,
    });
  };
}

export function clearActiveQuestion() {
  return (dispatch, getState) => {
    const activeQuestionSubscription = getState().activeQuestion
      .activeQuestionSubscription;

    if (activeQuestionSubscription) {
      activeQuestionSubscription.unsubscribe();
    }

    dispatch({
      type: types.CLEAR_ACTIVE_QUESTION,
    });
  };
}
